import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarChartReadComponent } from './bar-chart-read.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';


@NgModule({
  imports: [
    CommonModule,
    NgxChartsModule,
  ],
  declarations: [BarChartReadComponent],
  exports:[BarChartReadComponent],
})
export class BarChartReadModule { }
